import {
  PAGE_PORTAL_COMPANY,
  PAGE_PORTAL_DASHBOARD,
  PAGE_PORTAL_FINANCE,
  PAGE_PORTAL_FINANCE_INVOICES,
  PAGE_PORTAL_FINANCE_PAYMENTS,
  PAGE_PORTAL_FINANCE_RECEIPTS_LIST,
  PAGE_PORTAL_PROFILE,
  PORTAL_PREFIX
} from "@kivunova/kivufrontendcommon";
import { UserRole } from "../../components/Profile/enums/profileEnums";
import {
  canAccessDashboardAnalytics,
  canAccessStoreFinanceNav
} from "../../components/Navigation/constants/sidebarRoleAccess";
import type { SidebarNavConfigEntry } from "../types/sidebarNavConfigTypes";

/**
 * Manufacturing portal nav until M0 industry routes ship.
 * Order is defined by this array — adjust here only for manufacturing.
 */
export const MANUFACTURING_SIDEBAR_CONFIG: SidebarNavConfigEntry[] = [
  {
    labelKey: "sidebar-overview",
    defaultLabel: "Overview",
    icon: "grid",
    path: `${PORTAL_PREFIX}/${PAGE_PORTAL_DASHBOARD}`,
    testId: "sidebar-nav-dashboard",
    visible: canAccessDashboardAnalytics
  },
  {
    labelKey: "sidebar-finance",
    defaultLabel: "Finance",
    icon: "priceCheck",
    path: `${PORTAL_PREFIX}/${PAGE_PORTAL_FINANCE}`,
    testId: "sidebar-nav-finance",
    visible: canAccessStoreFinanceNav,
    children: [
      {
        labelKey: "sidebar-payments",
        defaultLabel: "Payments",
        icon: "paymentOutlined",
        path: `${PORTAL_PREFIX}/${PAGE_PORTAL_FINANCE_PAYMENTS}`,
        testId: "sidebar-nav-finance-payments"
      },
      {
        labelKey: "sidebar-invoices",
        defaultLabel: "Invoices",
        icon: "receipt",
        path: `${PORTAL_PREFIX}/${PAGE_PORTAL_FINANCE_INVOICES}`,
        testId: "sidebar-nav-finance-invoices"
      },
      {
        labelKey: "sidebar-receipts",
        defaultLabel: "Receipts",
        icon: "receipt",
        path: `${PORTAL_PREFIX}/${PAGE_PORTAL_FINANCE_RECEIPTS_LIST}`,
        testId: "sidebar-nav-finance-receipts"
      }
    ]
  },
  {
    labelKey: "sidebar-profile",
    defaultLabel: "Profile",
    icon: "person",
    path: `${PORTAL_PREFIX}/${PAGE_PORTAL_PROFILE}`,
    testId: "sidebar-nav-profile"
  },
  {
    labelKey: "sidebar-company",
    defaultLabel: "Company",
    icon: "storeOutlined",
    path: `${PORTAL_PREFIX}/${PAGE_PORTAL_COMPANY}`,
    testId: "sidebar-nav-company",
    visible: (role) => role === UserRole.COMPANY_ADMIN
  }
];
